import moment from 'moment'
import jobPrefix from '../../../common/service/jobPrefix.js'

const quoteHeaderTextSection = docData => {
  docData.doc.setFontSize(10)
  docData.doc.text(
    [
      moment().format('MMMM D YYYY') + '  Reference Number: ' + jobPrefix.get() + docData.job.jobNumber,
      'Valid for 30 Days',
    ],
    docData.doc.internal.pageSize.getWidth() / 2,
    docData.yAxis,
    { align: 'center' }
  )

  docData.yAxis += 2 * docData.doc.getFontSize() * 1.15 + docData.buffer

  return docData
}

export default quoteHeaderTextSection
